// extracted by mini-css-extract-plugin
export default {"container":"style_container__2qfBM","content":"style_content__18St1","descWrapper":"style_descWrapper__WM1eq"};